import { h, Component, Fragment } from 'preact';
import { legend } from '../config/config';

export default class InfoButtonsComponent extends Component {
    constructor() {
        super();
        const self = this;
        this.getLegendInfo().then(legend => {
            self.legendItems = legend;
        });

        this.state = {
            isLegendOpen: false,
            areContactsOpen: false
        };
    }

    async getLegendInfo() {
        try {
            const response = await fetch(`${legend.layerBaseUrl}/legend?f=json`);
            const legendData = await response.json();

            return legend.items.map(item => {
                let swatchSrc = null;
                try {
                    const layer = legendData.layers.find(x => x.layerId === item.colorId);
                    if (layer?.legend?.[0]?.imageData) {
                        swatchSrc = `data:${layer.legend[0].contentType};base64,${layer.legend[0].imageData}`;
                    }
                }
                catch (err) {
                    console.error(err);
                }

                return <li class="legend-item">
                    <span class="legend-symbol" style={swatchSrc ? `background-image: url('${swatchSrc}'); background-size: cover;` : ''}></span>
                    <span class="legend-item-label">{item.name}</span>
                </li>;
            });
        }
        catch (err) {
            console.log(err);
            console.log(`Could not load legend: ${err}`);
        }
    }

    formatTelephone(telephone) {
        if (telephone.length !== 10) {
            return telephone;
        }
        return `(${telephone.slice(0, 3)}) ${telephone.slice(3, 6)}-${telephone.slice(6, 10)}`;
    }

    openImportantInfo() {
        this.props.openImportantInfo();
    }

    openTsunamiInfo() {
        this.props.openTsunamiInfo();
    }

    toggleLegend() {
        this.setState({ isLegendOpen: !this.state.isLegendOpen });
        this.setState({ areContactsOpen: false });
    }

    toggleContacts() {
        this.setState({ areContactsOpen: !this.state.areContactsOpen });
        this.setState({ isLegendOpen: false });
    }

    render() {
        const self = this;
        return (
            <Fragment>
                {/* IMPORTANT INFO */}
                <button class="btn-orange btn-important-info-toggle" onclick={() => self.openImportantInfo()} data-ga="Menu: Important Information">
                    <span class="icon noclick">!</span>
                    <span class="hide-small button-text noclick">Important Information</span>
                </button>

                {/* TSUNAMI INFO */}
                <button class="btn-dark btn-tsunami-info-toggle" onclick={() => self.openTsunamiInfo()} data-ga="Menu: Tsunami Information">
                    <span class="icon noclick">?</span>
                    <span class="hide-small button-text noclick">Tsunami Information</span>
                </button>

                {/* LEGEND */}
                <div class="widget widget-legend">
                    <button class="btn-dark" onclick={() => self.toggleLegend()} data-ga="Menu: Legend">
                        <div class="icon noclick">
                            <span class="hamburger-line noclick"></span>
                            <span class="hamburger-line noclick"></span>
                            <span class="hamburger-line noclick"></span>
                        </div>
                        <span class="button-text hide-small noclick">Legend</span>
                    </button>

                    <div class={`dropdown-menu center legend ${self.state.isLegendOpen ? 'is-open' : ''}`}>
                        <div class="arrow"></div>
                        <ul role="list" class="legend-list">
                            {self.legendItems}
                        </ul>
                    </div>

                </div>

                {/* EMERGENCY CONTACTS */}
                <div class="widget widget-number-dropdown">
                    <button class="btn-dark" onclick={() => self.toggleContacts()} data-ga="Menu: Emergency Number">
                        <span class="icon center noclick">#</span>
                        <span class="text-hidden noclick button-text">Emergency Contacts</span>
                    </button>

                    <div class={`dropdown-menu right ${self.state.areContactsOpen ? 'is-open' : ''}`}>
                        <div class="arrow"></div>
                        <span class="dropdown-title">Emergency Number</span>
                        <p class="dropdown-item">
                            <small>
                                {self.props.selectedRegion.name}: <a tel={self.props.selectedRegion.telephone}
                                    title={`${self.props.selectedRegion.name} Emergency Management Telephone Number`} class="telephone-number">
                                    {self.formatTelephone(self.props.selectedRegion.telephone)}
                                </a>
                            </small>
                        </p>
                    </div>
                </div>
            </Fragment>
        );
    }
}
